module.exports = __webpack_public_path__ + "static/group-2-cf887df18e9f1e75a0c5f9f978fcfeb9.png";